import CardCounter from 'components/CardCounter';
import React, { useCallback, useEffect, useState } from 'react'
import IcPerson from 'assets/icons/ic-person.png';
import IcAgro from 'assets/icons/ic-agro.png';
import IcLuas from 'assets/icons/ic-luas.png';
import IcHome from 'assets/icons/ic-home.png';
import { getProfile } from 'services/apiRoutes';
import { useParams } from 'react-router-dom';

export default function CounterPage() {
  const {slug} = useParams()
  const [profile, setProfile] = useState();

  const profileAPI = useCallback(async () => {
    const res = await getProfile(slug);
    if (res.error) {
      return res.message;
    } else {
      const { data } = res.data;
      setProfile(data);
    }
  }, [slug]);

  useEffect(() => {
    profileAPI();
  }, [profileAPI]);

  return (
    <div className="relative px-5 space-y-16 bg-transparent py-36 wrapper xl:px-99">
      <h1 className="text-3xl font-bold">Gampong dalam angka</h1>
      <div className="relative items-center justify-between py-24 space-y-8 overflow-hidden border xl:px-20 xl:space-y-0 md:flex mainWrapper border-borderCardFeatures rounded-2xl">
        <div className="absolute left-0 rounded-full shadow -z-[1] top-1/2  w-[130px] h-[130px] orangeElipse" />
        <div className="absolute right-0 rounded-full shadow -z-[1] top-1/2  w-[130px] h-[130px] greenElipse" />

        <CardCounter
          icon={IcPerson}
          label="Jumlah Penduduk"
          counter={profile?.JumlahPenduduk}
          width={82.92}
          height={82.92}
        />
        <CardCounter
          icon={IcLuas}
          label="Luas Wilayah"
          counter={profile?.ProfilDesa?.luas_wilayah}
          width={83.29}
          height={83.33}
        />
        <CardCounter
          icon={IcAgro}
          label="Area Pertanian"
          counter={profile?.ProfilDesa?.luas_area_pertanian}
          width={79.17}
          height={82.97}
        />
        <CardCounter
          icon={IcHome}
          label="Permukiman dan
          Perumahan Gampong"
          counter={profile?.ProfilDesa?.luas_permukiman}
          width={75}
          height={83.43}
        />
      </div>
    </div>
  );
}
